import { h, Component } from "preact";
import queryString from "query-string";
import { connect } from "react-redux";

import ActionBar from "../../components/ActionBar";
import { pay, payClicked } from "../../state/actions/orderActions";
import { loadCheckOutScript } from "../../state/actions/payPalActions";

import PayPalService from "../../services/PayPalService";

import ZipMoney from "./ZipMoney";

import config from "../../config";

class PaymentPayPal extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    const {
      event,
      payPal,
      loadCheckOutScript,
      payClicked,
      pay,
      slug,
      orderId
    } = this.props;

    const parsed = queryString.parse(window.location.search);
    if (parsed.token && parsed.PayerID) {
      payClicked();
      // Set up the data you need to pass to your server
      var data = {
        orderId: parsed.token,
        payerId: parsed.PayerID
      };
      const eventId = event.data._id;
      // Make a call to your server to execute the payment
      pay(slug, orderId, "paypal", { orderId: data.orderId }, eventId);
      return;
    }

    if (!payPal.checkoutScript.loaded && !payPal.checkoutScript.loading) {
      loadCheckOutScript();
    } else {
      this.addPayPalBtn();
    }
  }

  addPayPalBtn() {
    const { event, slug, orderId, order, payPal, pay, payClicked } = this.props;
    const eventId = event.data._id;

    window.paypal.Button.render(
      {
        env: config("PAYPAL_ENV"),
        commit: true,
        style: {
          label: "pay",
          size: "responsive", // small | medium | large | responsive
          shape: "rect", // pill | rect
          color: "blue" // gold | blue | silver | black
        },
        // payment() is called when the button is clicked
        payment: function() {
          // Set up the payment
          return PayPalService.create(orderId)
            .then(function(data) {
              return data.id;
            })
            .catch(err => {
              console.error("err", err);
            });
        },
        // onAuthorize() is called when the buyer approves the payment
        onAuthorize: function(data, actions) {
          if (order.timeExpired) {
            return;
          }
          payClicked();
          // Set up the data you need to pass to your server
          var data = {
            orderId: data.paymentToken,
            payerId: data.payerID
          };
          // Make a call to your server to execute the payment
          pay(slug, orderId, "paypal", { orderId: data.orderId }, eventId);
        }
      },
      "#paypal-button-container"
    );
  }

  componentDidUpdate(prevProps) {
    const { orderId, payPal, loadCheckOutScript } = this.props;
    if (
      !prevProps.payPal.checkoutScript.loaded &&
      payPal.checkoutScript.loaded
    ) {
      this.addPayPalBtn();
    }
  }

  render({ order, payPal }) {
    return (
      <div>
        <p>
          All transactions are secure and encrypted. Payment information is
          never stored.
        </p>
        {!payPal.checkoutScript.loaded ||
        payPal.checkoutScript.loading ||
        order.waitingToPay ||
        order.paymentRequest.loading ? (
          <div class="loading loading-lg" />
        ) : !order.timeExpired ? (
          <div>
            <ZipMoney />
            <ActionBar>
              <div
                style={{
                  paddingTop: 12
                }}
              >
                <div id="paypal-button-container" />
              </div>
            </ActionBar>
          </div>
        ) : null}
      </div>
    );
  }
}
export default connect(
  state => ({ event: state.event, order: state.order, payPal: state.payPal }),
  { loadCheckOutScript, pay, payClicked }
)(PaymentPayPal);



// WEBPACK FOOTER //
// ./routes/payment/PaymentPayPal.js